import React from "react"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Paginator } from "primereact/paginator"
import styles from "../../styles/GenericTable.module.css"

const GenericSqlTable = ({
  data = [],
  columns,
  filters,
  header,
  rows,
  sortField = "date", // Default sort field is "date", can be overridden
  sortOrder = -1, // Default sort order is descending (-1), can be overridden
  onPageChange,
  onSortChange,
  totalCount,
  currentPage,
}) => {
  const safeData = data || []

  const onPage = (event) => {
    onPageChange(event.page + 1)
  }

  const onSort = (event) => {
    onSortChange(event.sortField, event.sortOrder)
  }

  const startRecord = (currentPage - 1) * rows + 1
  const endRecord = Math.min(currentPage * rows, totalCount)
  const footer = `Showing ${startRecord} to ${endRecord} of ${totalCount} records`

  return (
    <div className={styles["wrapper"]}>
      {header}
      <DataTable
        value={safeData}
        paginator={false}
        rows={rows}
        filters={filters}
        footer={footer}
        sortField={sortField} // Use sortField, default is "date"
        sortOrder={sortOrder} // Use sortOrder, default is descending (-1)
        emptyMessage="No records found"
        onSort={onSort}
      >
        {columns.map((col, index) => (
          <Column
            key={index}
            field={col.field}
            header={col.header}
            sortable={col.sortable}
            body={col.body}
          />
        ))}
      </DataTable>
      <Paginator
        first={(currentPage - 1) * rows}
        rows={rows}
        totalRecords={totalCount}
        onPageChange={onPage}
      />
    </div>
  )
}

export default GenericSqlTable
